import styles from "./style.module.scss";
import Image1 from "src/assets/photo-gallery/photo9.jpg";
import Image2 from "src/assets/photo-gallery/photo10.jpg";
import Image3 from "src/assets/photo-gallery/photo11.jpg";
import Image4 from "src/assets/photo-gallery/photo12.jpg";
import Image5 from "src/assets/living.jpg";
import Image6 from "src/assets/photo-gallery/photo13.jpg";
import clsx from "clsx";

export const CommitmentSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>石巻マリンヴィレッジ​​のこだわり​</h2>
        <h3>地域の暮らしに溶け込める設計</h3>
        <p>
          石巻市新館地区の住宅地の中に分譲地があり、かつ石巻マリンヴィレッジの住宅棟も宿泊棟も同じ外観で作られています。また、敷地内には他の家との境界線がなく、外キッチンなど共同で使える設備も多いことから、地域の生活に自然に入り込める空間になっています。
        </p>
      </div>
      <div className={styles.imageBox}>
        <div className={styles.leftBox}>
          <img src={Image1} alt="Image1" />
        </div>
        <div className={styles.rightBox}>
          <img src={Image2} alt="Image2" />
        </div>
        <div className={styles.grayBox} />
      </div>

      <div className={clsx(styles.innerBox, styles.mt60)}>
        <h3>マリンアクティビ﻿ティ好きには嬉しい工夫</h3>
        <p>
          一般的な住宅よりも天井が30cm高く、かつ玄関の奥行きも広いため、サーフボードや釣り竿を室内で余裕を持って保管できます。また、室内外に設置した蛇口で、サーフボードやウェアなどを水で洗い流してから室内に入れることも可能。かつ、玄関からキッチンまでの距離が近く、魚の処理もしやすいのも、マリンアクティビティ好きの人には嬉しいポイントです。
        </p>
      </div>
      <div className={styles.imageBox}>
        <div className={styles.leftBox}>
          <img src={Image3} alt="Image3" />
        </div>
        <div className={styles.rightBox}>
          <img src={Image4} alt="Image4" />
        </div>
        <div className={styles.grayBox} />
      </div>

      <div className={clsx(styles.innerBox, styles.mt)}>
        <h3>固定の家具をあ﻿えて減らして自由にレイアウト可能</h3>
        <p>
          棟内には固定された重たい家具がほとんどありません。これは、宿泊者が全体を使いやすくアレンジできるようにするためです。また、寝具もベッドではなくロールタイプの布団にすることで、寝る場所や部屋ごとの人数も自由に決めることができます。自分たちが使いやすいようにレイアウトを自由に変えられるのが特徴です。
        </p>
      </div>
      <div className={styles.imageBox}>
        <div className={styles.leftBox}>
          <img src={Image5} alt="Image5" />
        </div>
        <div className={styles.rightBox}>
          <img src={Image6} alt="Image6" />
        </div>
        <div className={styles.grayBox} />
      </div>
    </section>
  );
};
